import React, { useCallback, useEffect, useState } from "react";
import { Button, Checkbox, Col, Input, Radio, Row } from "antd";
import { useTranslation } from "react-i18next";
import { SelectTypeTransport } from "../../../../components/selects";
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import { EntAgroTransportItem } from "../../../../models/agroTransportItem";

interface IProps {
	setItems: (items: EntAgroTransportItem[]) => void;
	items: EntAgroTransportItem[] | null;
}

export const TransportItems: React.FC<IProps> = ({ setItems, items }) => {
	const { t } = useTranslation();
	const [realEstateItems, setRealEstateItems] = useState<EntAgroTransportItem[]>([]);

	// Функция для генерации уникального ключа
	const generateUniqueKey = (): number => {
		return Math.random();
	};

	// Создание нового элемента с уникальным ключом
	const createNewItem = (): EntAgroTransportItem => ({
		key: generateUniqueKey(),
		id: null, // Добавлено id
		seasonStatus: false,
		totalQuantity: null,
		functionalQuantity: null,
		checkStatus: false,
		description: null,
		typeId: null,
		type: null,
	});

	useEffect(() => {
		if (items && items.length > 0) {
			const itemsWithKeys = items.map((item) => ({
				...item,
				key: item.key || generateUniqueKey(),
			}));
			setRealEstateItems(itemsWithKeys);
		} else {
			setRealEstateItems([createNewItem()]);
		}
	}, []); 

	useEffect(() => {
		setItems(realEstateItems);
	}, [realEstateItems]); 

	const handleAddItem = useCallback(() => {
		setRealEstateItems((prevItems) => [...prevItems, createNewItem()]);
	}, []);

	const handleDeleteItem = useCallback(
		(key: number) => {
			if (realEstateItems.length > 1) {
				const updatedItems = realEstateItems.filter((item) => item.key !== key);
				setRealEstateItems(updatedItems);
				setItems(updatedItems);
			}
		},
		[realEstateItems, setItems]
	);

	const handleInputChange = useCallback(
		(key: number, field: keyof EntAgroTransportItem, value: any) => {
			setRealEstateItems((prevItems) =>
				prevItems.map((item) =>
					item.key === key
						? {
							...item,
							[field]: value,
							...(field === "checkStatus" && !value
								? { seasonStatus: false, functionalQuantity: null }
								: {}),
						}
						: item
				)
			);
		},
		[]
	);

	const isFieldEmpty = (value: any): boolean => {
		return value === null || value === undefined || value === "";
	};

	return (
		<div style={{ marginTop: 15 }}>
			{realEstateItems.map((item) => (
				<div key={item.key} className="block_item_form massive_blocks">
					<Button
						type="primary"
						className="fixed_delete"
						danger
						icon={<CloseOutlined />}
						shape="circle"
						size="small"
						disabled={realEstateItems.length === 1}
						onClick={() => handleDeleteItem(item.key as number)}
					/>
					<Row style={{ margin: 0 }} gutter={16}>
						<Col className="gutter-row" span={12}>
							<label>{t("Транспорт")}</label>
							<SelectTypeTransport
								value={item.typeId}
								onChange={(value) => handleInputChange(item.key as number, "typeId", value)}
								status={isFieldEmpty(item.typeId) ? "error" : ""}
							/>
						</Col>
						<Col className="gutter-row" span={12}>
							<label>{t("Количество единиц транспорта")}</label>
							<Input
								type="number"
								className={isFieldEmpty(item.totalQuantity) ? "error-border" : ""}
								value={item.totalQuantity || ""}
								onChange={(e) =>
									handleInputChange(item.key as number, "totalQuantity", Number(e.target.value))
								}
							/>
						</Col>
						<Col style={{ marginTop: 10 }} className="gutter-row" span={12}>
							<div style={{ margin: "10px 0px" }}>
								<Checkbox
									checked={item.checkStatus}
									onChange={(e) =>
										handleInputChange(item.key as number, "checkStatus", e.target.checked)
									}
								>
									{t("Учет состояния техники")}
								</Checkbox>
							</div>
							{item.checkStatus && (
								<div>
									<div style={{ margin: "10px 0" }}>
										<label>{t("Статус сезона")}</label>
										<Radio.Group
											value={item.seasonStatus}
											onChange={(e) =>
												handleInputChange(item.key as number, "seasonStatus", e.target.value)
											}
										>
											<Radio value={true}>{t("Осенние работы")}</Radio>
											<Radio value={false}>{t("Весенние работы")}</Radio>
										</Radio.Group>
									</div>
									<label>{t("Количество единиц исправного транспорта")}</label>
									<Input
										type="number"
										value={item.functionalQuantity || ""}
										onChange={(e) =>
											handleInputChange(item.key as number, "functionalQuantity", Number(e.target.value))
										}
									/>
								</div>
							)}
						</Col>
						<Col style={{ marginTop: 10 }} className="gutter-row" span={12}>
							<label>{t("mechanisation.transport.description")}</label>
							<TextArea
								rows={4}
								value={item.description || ""}
								onChange={(e) =>
									handleInputChange(item.key as number, "description", e.target.value)
								}
							/>
						</Col>
					</Row>
				</div>
			))}
			<Button
				style={{ marginTop: 15 }}
				icon={<PlusCircleOutlined />}
				type="primary"
				onClick={handleAddItem}
			>
				{t("Добавить еще элемент")}
			</Button>
		</div>
	);
};